import React, { Component } from 'react'
import { routerMiddleware, push } from 'react-router-redux';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from 'moment'
import shortid from 'shortid'
import Hashids from 'hashids';
import abbreviate from 'number-abbreviate';

import Pattern from '../Pattern/Pattern.js';
import generateName from '../../pattern_utilities/generateName.js';
import {
  pmSetCurrentPattern,
  tryToSaveACopy,
  downloadText,
  tryToDeletePattern,
  showTooltip,
  hideTooltip, 
  tryToLogDownload
} from '../../actions/actions.export.js';

import './PatternThumbnail.css';


var hashids = new Hashids('k100p');

class PatternThumbnail extends Component {
  static propTypes = {
    cacheID: PropTypes.string.isRequired
  }

  constructor(props){
    super(props);
  }

  render(){
    const { dispatch, patternManager, cacheID, user, team } = this.props;
    const p = patternManager.pristineCache[cacheID];

    if(!p) return <div className="pattern-thumbnail "/> 

    let my_scope = user.id;
    let myRole = 'admin'
    if(team.current){
      if(team.cache[team.current]){
        my_scope = team.cache[team.current].id;
        myRole = team.cache[team.current].myRole;
      }
    }

    let url = '/pat/' + hashids.encode(p.id);
    if(this.props.registerBeforeNavigating){
      url = "/sign-up?after=" + window.btoa(url);
      if(this.props.registerBeforeNavigatingIntro){
        url += "&in=" + window.btoa(this.props.registerBeforeNavigatingIntro);
      }
      if(this.props.registerBeforeNavigatingTagline){
        url += "&tg=" + window.btoa(this.props.registerBeforeNavigatingTagline);
      }
      url += "&p=" + window.btoa(cacheID);
    }

    return <div 
      className={"pattern-thumbnail " + (this.props.noLink ? ' pattern-thumbnail-no-link ' : 'test') + (this.props.locked ? ' pattern-thumbnail-locked' : '') + (p.private ? ' pattern-thumbnail-private' : '') + (this.props.tiny ? ' pattern-thumbnail-tiny' : '')} 
      onMouseEnter={(e)=>{ 
        if(this.props.locked){
          dispatch(showTooltip({
            e: e,
            position: 'top', 
            lag: 100,
            nobr: false,
            content: <div style={{width: 225}}>
              {this.props.lockedMessage}
            </div>
          }))
        }
      }} 
      onMouseLeave={(e)=>{ if(this.props.locked) dispatch(hideTooltip()) }}
      key={p.updated_on}
      >
      <Link 
        to={url}
        onClick={(e)=>{ 
          if(!this.props.locked){
            // dispatch(pmSetCurrentPattern({cacheID: cacheID}));
            if(this.props.onClick) this.props.onClick();
          } else {
            e.preventDefault();
          }
        }}
        >
        <div className="pattern-thumbnail-preview">
          <div className="pattern-thumbnail-image-wrapper">
            <div className="pattern-thumbnail-image"
              style={{
                backgroundImage: 'url(' + (p.image_url ? (p.image_url + "?" + p.updated_on) : p.thumbnailDataUrl) + ')',
              }}>
              {/*<img src={ p.image_url ? (p.image_url + "?" + p.updated_on) : p.thumbnailDataUrl} className="pattern-thumbnail-image"/>*/}
            </div>
          </div>
          {/*
          {(p.mode === 'drawing') && <i className="pattern-thumbnail-icon bg-secondary fal fa-lg fa-fw fa-pencil"/> }
          {(p.mode === 'template') && <i className="pattern-thumbnail-icon bg-primary fal fa-lg fa-fw fa-calculator"/> }
          */}
          {
            this.props.locked && <div className="pattern-thumbnail-lock-overlay">
              <i className="fal fa-lock-alt fa-2x text-primary"/>
            </div>
          }
        </div>
      </Link>
      <div className="pattern-thumbnail-info">
        <div className="pattern-thumbnail-info-left text-ellipsis">
         
            {
              this.props.tiny ? <div className="pattern-thumbnail-name text-ellipsis">
                {generateName(p)}&nbsp;
              </div> 
              :
              <div>
                <div className="pattern-thumbnail-name text-ellipsis">
                  {generateName(p)}&nbsp;
                </div>
                {
                  !this.props.simple && 
                  <div className="pattern-thumbnail-date text-ellipsis">
                    {moment(p.updated_on || p.created_on).fromNow()}
                    {
                      (!this.props.official && p.scope !== p.created_by) && <span> by {
                        p.created_by == user.id ? "you" : p.created_by_name
                      }
                      </span>
                    }
                    { (this.props.official && p.stats && p.stats.downloads) && <span>&nbsp;|&nbsp;{abbreviate(p.stats.downloads)} download{p.stats.downloads > 1 && "s"}</span> }

                  </div>
                }
              </div>
            }
        </div>
        <div className="pattern-thumbnail-icon-inline">
          {(p.mode === 'template') && <i className="text-muted fal fa-fw fa-calculator"/>}
          {(p.mode === 'drawing') && <i className="text-muted fal fa-fw fa-pencil"/>}
        </div>
        {
          (p.scope === my_scope && !this.props.tiny && !this.props.simple) && 
          <div className="pattern-thumbnail-menu-wrapper">
            <div className="dropdown">
              <a className="dropdown-toggle " href="#" role="button" id={"pat-thumb-" + cacheID} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="far fa-fw fa-angle-down fa-lg"/>
              </a>

              <div className="dropdown-menu dropdown-menu-right" aria-labelledby={"pat-thumb-" + cacheID}>
                <span
                  onClick={(e)=> { 
                    dispatch(tryToSaveACopy(p));
                    e.preventDefault() 
                  }}
                  className={"dropdown-item dropdown-item-flex dropdown-item-link"}
                  >
                  <span className="dropdown-item-icon">
                    <i className={"fal fa-copy fa-fw"}/>
                  </span>
                  <span className="dropdown-item-label">
                    Make a copy
                  </span>
                </span>

                <span
                  onClick={(e)=> { 
                    dispatch(tryToLogDownload({id: p.id}));
                    dispatch(downloadText({
                      cacheID: p.id,
                      user: user,
                      team: team.current ? team.cache[team.current] : false,
                      includeErrors: true
                    }));
                    e.preventDefault() 
                  }}
                  className={"dropdown-item dropdown-item-flex dropdown-item-link"}
                  >
                  <span className="dropdown-item-icon">
                    <i className={"fal fa-file-download fa-fw"}/>
                  </span>
                  <span className="dropdown-item-label">
                    Download .PAT
                  </span>
                </span>

                {
                  myRole === 'admin' && <div className="dropdown-divider"></div>
                }

                {
                  myRole === 'admin' && 
                  <span
                    onClick={(e)=> { 
                      dispatch(tryToDeletePattern(p.id));
                    }}
                    className={"dropdown-item dropdown-item-flex dropdown-item-link"}
                    >
                    <span className="dropdown-item-icon">
                      <i className={"fal fa-trash fa-fw"}/>
                    </span>
                    <span className="dropdown-item-label text-700 text-danger">
                      Delete
                    </span>
                  </span>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
}


const mapStateToProps = (state) => {
  const { 
    patternManager, user, team
  } = state;

  return {
    patternManager, user, team
  }
}

export default connect(mapStateToProps)(PatternThumbnail);


// WEBPACK FOOTER //
// ./src/components/PatternThumbnail/PatternThumbnail.js